import { Link } from 'react-router-dom';

export default function AcademyBreadcrumbs({ current, authenticated = false }) {
  return <nav aria-label="Breadcrumb" className="mb-4"><ol className="breadcrumb mb-0">
    <li className="breadcrumb-item"><Link to={authenticated ? '/app/academy' : '/academy'}>Academy</Link></li>
    {current && <li className="breadcrumb-item active" aria-current="page">{current}</li>}
  </ol></nav>;
}
